// CSS
import styles from "./card.module.scss";
import parse from "html-react-parser";

export const Card = (props) => {
    const { data, onClick } = props;
    const { conference, image, preview, title } = data;

    return (
        <div className={styles.card} onClick={onClick}>
            <div
                className={styles.image}
                style={{
                    backgroundImage: `url(${image?.sizes?.medium_large})`,
                }}
            />
            <div className={styles.body}>
                <div className={styles.top}>
                    <div className={styles.title}>
                        {title && <span>{parse(data.title)}</span>}
                    </div>
                    <div className={styles.preview}>{preview}</div>
                </div>
                <div className={styles.bottom}>
                    <div className={styles.category}>{conference}</div>
                </div>
            </div>
        </div>
    );
};
